import { useEffect, useState } from "react";
import styles from "./SetNewPassword.module.css";

import { useNavigate, useLocation } from "react-router-dom";

import BackToLoginPageButton from "../../Components/BackToLoginPageButton/BackToLoginPageButton";
import { ValidatePassword } from "../../Utils/ValidatePassword";
import { setNewPassword } from "../../Api/Backend/Auth";


// .../login/set-new-password
function SetNewPassword() {
    const location = useLocation();
    const navigate = useNavigate();

    const [token, setToken] = useState(null);
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [passwordMessage, setPasswordMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [isSending, setIsSending] = useState(false);
    const [isPasswordCreated, setIsPasswordCreated] = useState(false);

    useEffect(() => {
        setPasswordMessage(ValidatePassword(password, passwordConfirm));
    }, [password, passwordConfirm]);

    const handleSubmitPassword = async (e) => {
        e.preventDefault();

        if (passwordMessage || !password || !passwordConfirm) return;

        setErrorMessage(null);
        setIsSending(true);

        await setNewPassword({
            token: token,
            password: password,
            onSuccess: () => {
                setIsPasswordCreated(true);
            },
            onError: (error) => {
                setErrorMessage(error.message || "비밀번호 변경 중 오류가 발생했습니다.");
            }
        });

        setIsSending(false);
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const t = params.get("token");

        if (!t) {
            navigate("/login/password-reset-request", { replace: true });
        } else {
            setToken(t);
        }

    }, [location.search, navigate]);

    return (
        <div className={styles.setNewPassword}>
            <img className={styles.acornIcon} src="/images/logo.svg" alt="에이콘 로고" />
            <div className={styles.title}>
                {isPasswordCreated ? "비밀번호가 성공적으로 변경되었습니다" : "비밀번호 변경"}
            </div>

            <div className={styles.description}>
                {isPasswordCreated
                    ? "이제 새 비밀번호로 로그인하실 수 있습니다."
                    : "새 비밀번호를 입력해 주세요."}
            </div>

            {isPasswordCreated ? (
                <BackToLoginPageButton />
            ) : (
                <form className={styles.passwordForm} onSubmit={handleSubmitPassword}>
                    <input
                        className={styles.inputBox}
                        type="password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="비밀번호를 입력해 주세요"
                        disabled={isSending}
                    />
                    <input
                        className={styles.inputBox}
                        type="password"
                        name="passwordConfirm"
                        value={passwordConfirm}
                        onChange={(e) => setPasswordConfirm(e.target.value)}
                        placeholder="비밀번호를 한번 더 입력해 주세요"
                        disabled={isSending}
                    />
                    {passwordMessage !== null &&
                        <div className={styles.passwordError}>{passwordMessage}</div>
                    }

                    <button
                        className={styles.sendPassword}
                        type="submit"
                        disabled={isSending || passwordMessage || !password || !passwordConfirm}
                    >
                        비밀번호 설정
                    </button>
                </form>
            )}

            {errorMessage &&
                <div className={styles.errorMessage}>{errorMessage}</div>
            }

        </div>
    );
}

export default SetNewPassword;